
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/webtoons/[pageNumber]",
      function () {
        return require("private-next-pages/webtoons/[pageNumber]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/webtoons/[pageNumber]"])
      });
    }
  